// src/components/AurusImageBlock.jsx
import aurusImg from '../../assets/img/Aurus/bp-aurus/aurus.png';
import bpAurusImg from '../../assets/img/Aurus/bp-aurus/bp-aurus.jpg';


   
// <section className="bp-aurus">   10 строка
const AurusImageBlock = () => {
  return (
    <section className="aurus-image-block">
      <div className="wrapper">
      {/*  <img
          src=//{bpAurusImg} 
          alt="Aurus background"
          className="bp-aurus__img"
        />*/}
        <img
          src={aurusImg} 
          alt="Aurus logo"
          className="bp-aurus__aurus"
        />
      </div>
    </section>
  );
};

export default AurusImageBlock;
